"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom.iterable");
var _zhjySerach = _interopRequireDefault(require("@/components/search/zhjySerach.vue"));
var _funBtn = _interopRequireDefault(require("@/components/funBtn/funBtn.vue"));
var _zhjyTable = _interopRequireDefault(require("@/components/table/zhjyTable.vue"));
var _zhjyPagination = _interopRequireDefault(require("@/components/zhjyPagination/zhjyPagination.vue"));
var _projectType = require("@/api/project/projectType");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      queryGroup: [{
        label: "精确查找",
        type: "input",
        model: "queryValue",
        placeholder: "名称/编码"
      }],
      modelData: {
        queryValue: ""
      },
      defaultColumn: [{
        name: "项目类型名称",
        prop: "matchTypeName",
        isShow: true,
        width: "400"
      }
      // {
      //   name: "创建时间",
      //   prop: "createTime",
      //   isShow: true,
      //   width: "300",
      //   sortable: true,
      // },
      ],
      minWidth: 300,
      page: {
        pageNumber: 1,
        pageSize: 10
      },
      totalData: 0,
      listData: [],
      formatters: {
        belongAdministrator: []
      },
      sort: {
        prop: "",
        order: ""
      },
      queryValue: "",
      checkBoxs: [],
      options: [{
        name: "删除",
        class: "editor",
        option: "del",
        span: 5
      }],
      funBtns: [{
        size: "small",
        click: "save",
        icon: "el-icon-circle-plus-outline",
        name: "新增",
        type: "primary"
      }, {
        size: "small",
        click: "deleteItem",
        icon: "el-icon-circle-close",
        name: "批量删除",
        type: "danger"
      }]
    };
  },
  methods: {
    // 删除、批量删除
    deleteItem: function deleteItem(row) {
      var _this = this;
      var id = [];
      if (!row && this.checkBoxs.length === 0) {
        return this.$message.error("请先勾选数据");
      } else if (row) {
        id.push(row.id);
      } else if (this.checkBoxs.length > 0) {
        id = this.checkBoxs;
      }
      this.$confirm("确认删除吗", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true
      }).then(function () {
        (0, _projectType.projectTypeDel)(id).then(function () {
          _this.getTypeList();
          _this.$message.success("操作成功。");
        });
      }).catch(function () {
        _this.$message.info("取消删除。");
      });
    },
    // 精确查找
    search: function search(e) {
      this.queryValue = e.queryValue;
      this.getTypeList();
    },
    // 获取项目类型列表
    getTypeList: function getTypeList() {
      var _this2 = this;
      (0, _projectType.projectTypeList)({
        matchTypeName: this.queryValue,
        pageNum: this.page.pageNumber,
        pageSize: this.page.pageSize
      }).then(function (res) {
        var data = res.data;
        _this2.listData = data.list;
        _this2.totalData = data.total;
      });
    },
    listBureau: function listBureau() {},
    dels: function dels() {},
    // 新增
    save: function save() {
      this.$router.push("/object/objectTag-add");
    },
    // 编辑
    edit: function edit(e) {
      this.$router.push({
        path: "/object/objectTag-edit",
        query: e
      });
    },
    handleSelectionChange: function handleSelectionChange(e) {
      var _this3 = this;
      this.checkBoxs = [];
      e.forEach(function (item) {
        _this3.checkBoxs.push(item.id);
      });
    },
    deleteById: function deleteById() {},
    distribution: function distribution() {},
    viewAdmin: function viewAdmin() {},
    sortChange: function sortChange() {},
    handleCurrentChange: function handleCurrentChange(e) {
      this.page.pageNumber = e;
      this.getTypeList();
    },
    handleSizeChange: function handleSizeChange(e) {
      this.page.pageSize = e;
      this.page.pageNumber = 1;
      this.getTypeList();
    }
  },
  created: function created() {
    this.getTypeList();
  },
  components: {
    ZhjySerach: _zhjySerach.default,
    ZhjyPagination: _zhjyPagination.default,
    FunBtn: _funBtn.default,
    ZhjyTable: _zhjyTable.default
  }
};